import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Login = () => {
    const [credentials, setCredentials] = useState({
        email: '',
        password: ''
    });
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const { login } = useAuth();

    const handleChange = (e) => {
        setCredentials({
            ...credentials,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        
        try {
            await login(credentials);
            navigate('/admin');
        } catch (err) {
            setError('Invalid credentials. Please try again.');
        }
    };

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'linear-gradient(to right, #e0f2fe, #dbeafe, #e0e7ff)'
        }}>
            <div style={{
                width: '100%',
                maxWidth: '28rem',
                margin: '1rem',
                padding: '2rem',
                background: 'rgba(255, 255, 255, 0.7)',
                backdropFilter: 'blur(8px)',
                borderRadius: '1rem',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                border: '1px solid rgba(255, 255, 255, 0.2)'
            }}>
                <div className="text-center mb-8">
                    <h1 className="text-3xl font-bold text-sky-900 mb-2">Welcome Back</h1>
                    <p className="text-sky-700">Please sign in to your account</p>
                </div>

                {error && (
                    <div className="mb-6 bg-red-50 border-l-4 border-red-500 p-4 text-red-700">
                        <p className="font-medium">Login failed</p>
                        <p className="text-sm">{error}</p>
                    </div>
                )}

                <form onSubmit={handleSubmit} className="space-y-6">
                    <div>
                        <label className="block text-sm font-medium text-sky-800 mb-2">
                            Email Address
                        </label>
                        <input
                            type="email"
                            name="email"
                            value={credentials.email}
                            onChange={handleChange}
                            className="w-full px-4 py-3 rounded-lg bg-white/50 border border-sky-200 focus:ring-2 focus:ring-sky-400 focus:border-transparent transition duration-200"
                            placeholder="Enter your email"
                            required
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-sky-800 mb-2">
                            Password
                        </label>
                        <input
                            type="password"
                            name="password"
                            value={credentials.password}
                            onChange={handleChange}
                            className="w-full px-4 py-3 rounded-lg bg-white/50 border border-sky-200 focus:ring-2 focus:ring-sky-400 focus:border-transparent transition duration-200"
                            placeholder="Enter your password"
                            required
                        />
                    </div>

                    <div className="flex items-center justify-between">
                        <div className="flex items-center">
                            <input
                                type="checkbox"
                                id="remember"
                                className="h-4 w-4 text-sky-500 focus:ring-sky-400 border-sky-300 rounded"
                            />
                            <label htmlFor="remember" className="ml-2 block text-sm text-sky-800">
                                Remember me
                            </label>
                        </div>
                        <Link 
                            to="/forgot-password" 
                            className="text-sm font-medium text-sky-600 hover:text-sky-500"
                        >
                            Forgot password?
                        </Link>
                    </div>

                    <button
                        type="submit"
                        className="w-full bg-gradient-to-r from-sky-500 to-blue-500 text-white py-3 px-4 rounded-lg hover:from-sky-600 hover:to-blue-600 focus:outline-none focus:ring-2 focus:ring-sky-400 focus:ring-offset-2 transform transition-all duration-200"
                    >
                        Sign in
                    </button>
                </form>

                <div className="mt-6 text-center text-sm">
                    <span className="text-sky-700">Don't have an account? </span>
                    <Link 
                        to="/register" 
                        className="font-medium text-sky-600 hover:text-sky-500"
                    >
                        Sign up
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default Login; 